// extracted by mini-css-extract-plugin
module.exports = {"slideshowContainer":"styles-module--slideshowContainer--1iE6I","slide":"styles-module--slide--3fAMH"};